import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const data = [
  {
    category: 'Generative AI',
    '2024': 1.5, // Billion USD
    '2030': 10,  // Billion USD
  },
  {
    category: 'Total AI Market',
    '2024': 6.5, // Estimated Billion USD
    '2030': 28,  // Billion CAD (chart implies comparable scale)
  },
];

const formatCurrency = (value: number) => {
  return `$${value}B`; // Display in billions
};

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="p-4 bg-card border border-border rounded-md shadow-lg">
        <p className="font-bold text-foreground mb-2">{label}</p>
        {payload.map((entry: any, index: number) => (
          <p key={`item-${index}`} style={{ color: entry.color }}>
            {`${entry.name}: $${entry.value}B`}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

const MarketOpportunityChart = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="w-full h-[400px] md:h-[500px] lg:h-[600px] bg-card/50 p-4 rounded-lg"
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--muted))" />
          <XAxis dataKey="category" stroke="hsl(var(--foreground))" />
          <YAxis
            tickFormatter={formatCurrency}
            stroke="hsl(var(--foreground))"
            domain={[0, 30]} // Max value is 28B, so 30B is a good upper bound
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'hsl(var(--muted) / 0.2)' }} />
          <Legend />
          <Bar dataKey="2024" fill="hsl(354 82% 30%)" name="2024 (Billion USD)" />
          <Bar dataKey="2030" fill="hsl(var(--primary))" name="2030 (Billion USD)" />
        </BarChart>
      </ResponsiveContainer>
    </motion.div>
  );
};

export default MarketOpportunityChart;